import { useState } from 'react';

export const usePathParams = (orderBy, limit = 15, order = 'asc') => {
  const [queryParams, setQueryParams] = useState({
    limit,
    query: '',
    offset: 0,
    orderBy,
    order,
  });

  function buildQueryString() {
    return `?${new URLSearchParams(queryParams)}`;
  }

  return {
    queryParams,
    setQueryParams,
    buildQueryString,
  };
};
